module.exports = __webpack_public_path__ + "static/media/corpu_doc1.1afc196c.JPG";